module.exports = __webpack_public_path__ + "static/media/post-icon.fe240a9a.svg";